import React from "react";
import CmsPage from "../CmsPage/CmsPage";
import "./Faqs.scss";

const Faqs = () => {
  return <CmsPage id={4} />;
};

export default Faqs;
